import Vue from 'vue';
import axios from 'axios';

export async function getChildCoinsInformation({ commit }, childId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: '/child/' + childId + '/getPointCount/'
  })
    .then(response => {
      commit('saveCoinsInfo', response.data);
    })
    .catch(error => {
      commit('error', error);
    });
}

export async function getChildLevelInformation({ commit }, childId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: '/ranking/?count=10&user=' + childId
  })
    .then(response => {
      commit('saveLevelInfo', response.data);
    })
    .catch(error => {
      commit('error', error);
    });
}

export async function getChildCoinsPending({ commit }, childId) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'GET',
    url: '/child/' + childId + '/getCoinsPending/'
  })
    .then(response => {
      commit('saveCoinsPending', response.data);
    })
    .catch(error => {
      commit('error', error);
    });
}

export async function aceptRejectCoin({ commit }, payload) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'POST',
    url: '/point/' + payload.id + '/activate/',
    data: {
      value: payload.value
    }
  })
    .then(response => {
      //console.log(response)
    })
    .catch(error => {
      commit('error', error);
    });
}

export async function setCoinsValues({ commit }, payload) {
  commit('cleanErrors');
  await Vue.axios({
    method: 'POST',
    url: '/child/' + payload.childId + '/setCoinsValues/',
    data: payload.items
  })
    .then(response => {})
    .catch(error => {
      commit('error', error);
    });
}
